module.exports = __webpack_public_path__ + "static/media/oops-image.d471057d.svg";